import React from 'react';
import ReactDOM from 'react-dom';

import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

const ProgramSlider = (props) => {

    let Items = props.sliderNews.map((pcat, i) => {
    // console.log("props slider news: "+news.Title);
    
        let short_title = "";
        if((pcat.title).length > 200){
            short_title = pcat.title.substring(0, 200)+"...";
        }
        else {
            short_title = pcat.title;
        }

        return (
                <div className="card" key={i}>
                    <div className="item">
                        <div className="card">
                            <a newsid={pcat.id} href={"/ProgramsList/"+pcat.id} >
                                <div className="img-card">
                                    <img src={pcat.image} className="card-img-top" alt={short_title} />
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
        );

    });

    const options = {
        items: 2,
        nav: false,
        loop: false,
        dots: false,
        stagePadding: 30
    };

    return (
        <div>
            <OwlCarousel className="owl-theme" loop margin={15} {...options}>
                    {Items}
            </OwlCarousel>
        </div>
    );
}

export default ProgramSlider;